import { useRef } from 'react';
import PropTypes from 'prop-types';
import { X } from '@phosphor-icons/react/dist/ssr/X';
import { Camera } from '@phosphor-icons/react/dist/ssr/Camera';

/**
 * HostPhotoChip — `[📷 Take photo] ✕`, the host's photo prompt.
 *
 * ONE home, extracted 2026-08-16 when THREAD needed the same chip above the
 * composer (`profile_3`) that `JustFormedCard` already showed on the People
 * card. It owns the chip, the dismiss, and the hidden `capture="user"` input
 * together — they are one control, and a second copy would be a second place
 * for the capture attribute to drift.
 *
 * `capture="user"` opens the camera directly on iOS rather than the library:
 * this prompt is about the moment you are in, not a photo you already have.
 * (The library door lives only in the SP's own QR-customize sheet.)
 *
 * @param {function} onTakePhoto - receives the File
 * @param {function} onSkip - dismiss; the prompt never nags twice
 */
const HostPhotoChip = ({ onTakePhoto, onSkip, onTap, style }) => {
  const cameraInputRef = useRef(null);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', ...style }}>
      <div
        onClick={() => {
          onTap?.();
          cameraInputRef.current?.click();
        }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 14px',
          backgroundColor: '#FFFFFF',
          borderRadius: '18px',
          boxShadow: '0 1px 4px rgba(0,0,0,0.10)',
          fontSize: '14px',
          fontWeight: '500',
          color: '#000000',
          cursor: 'pointer',
        }}
      >
        <Camera size={16} />
        Take photo
      </div>
      <div onClick={onSkip} style={{ padding: '6px', cursor: 'pointer', display: 'flex' }}>
        <X size={16} color="#C2C2C8" />
      </div>
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="user"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onTakePhoto(file);
        }}
        style={{ display: 'none' }}
      />
    </div>
  );
};

HostPhotoChip.propTypes = {
  onTakePhoto: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  onTap: PropTypes.func,
  style: PropTypes.object,
};

export default HostPhotoChip;
